import { render, staticRenderFns } from "./mandatoryChecks.vue?vue&type=template&id=042480be&scoped=true&"
import script from "./mandatoryChecks.vue?vue&type=script&lang=js&"
export * from "./mandatoryChecks.vue?vue&type=script&lang=js&"
import style0 from "./mandatoryChecks.vue?vue&type=style&index=0&id=042480be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042480be",
  null
  
)

export default component.exports